module.exports = __webpack_public_path__ + "img/recommended.95f308a0.png";